<template>
  <!-- Section board -->
  <div class="pa-0 mx-0 mt-2">
    <v-responsive id="articles-board" class="primary--text" relaive>
      <div class="section_inner">
        <v-container fluid>
          <v-row class="pa-0">
            <v-col cols="12" class="pa-md-0">
              <v-row id="articles-search">
                <v-col cols="12" class="pa-3 mt-2">
                  <h1 class="display-60-30 font-weight-medium" v-html="header" />
                </v-col>
                <v-col cols="12" class="pt-0 pa-3">
                  <h2 class="display-26-20 text-right" v-html="subHeader" />
                </v-col>
                <v-col
                  cols="12"
                  sm="9"
                  md="6"
                  class="mt-0 mt-md-4"
                  v-if="showSearch"
                >
                  <SearchInPage class="articles-search" />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-responsive>
  </div>
  <!-- Section board -->
</template>

<script>
import SearchInPage from './SearchInPage.vue';

export default {
  components: {
    SearchInPage,
  },
  props: {
    header: {
      type: String,
      required: false,
      default: 'כל הקטגוריות',
    },
    subHeader: {
      type: String,
      required: false,
      default:
        'עמוד דרושים הייטק מרכז עבור העובדים בהייטק את כל הלינקים הרלוונטיים',
    },
    showSearch: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
#articles-board {
  background: transparent url('/img/categories/top/small.jpg') bottom center
    no-repeat;
  background-size: cover;
  position: relative;
  overflow: unset;
  z-index: 0;
  height: 267px;
}

.articles-category #articles-board {
  background: transparent url('/img/article_category.png') bottom center
    no-repeat;
}
.articles-lobby #articles-board {
  background: transparent url('/img/plazma_article_mobile.jpg') left center
    no-repeat;
}
.calculator #articles-board {
  background: transparent url('/img/plazma_calculator.jpg') bottom center
    no-repeat;
}

#articles-search {
  text-align: center;
}

.v-text-field > .v-input__control > .v-input__slot:after {
  width: 0px;
}

h1,
h2 {
  text-shadow: 0px 0px 5px #ffffff, 0px 0px 10px #ffffff, 0px 0px 10px #ffffff,
    0px 0px 20px #ffffff, 0px 0px 20px #ffffff, 0px 0px 20px #ffffff,
    0px 0px 20px #ffffff;
  line-height: 1.2;
}

@media only screen and (min-width: 600px) {
  #articles-board {
    background: transparent url('/img/categories/top/top.jpg') bottom center
      no-repeat;
    height: 315px;
    background-size: cover;
    position: relative;
    overflow: unset;
    z-index: 0;
  }
  .articles-lobby #articles-board {
    background: transparent url('/img/plazma_artical.jpg') bottom center
      no-repeat;
    background-size: cover;
  }

  .calculator #articles-board {
    background: transparent url('/img/plazma_calculator.jpg') bottom center
      no-repeat;
      
  }

  #articles-search {
    text-align: right;
  }
}
</style>
